import { createListenerMiddleware } from '@reduxjs/toolkit';

import type { CoreRootState } from '../CoreStore';
import { getChipWeightFromIndex } from '../../utils/chips';
import { fetchTableConfigAction } from '../apiActions/fetchTableConfigAction';
import { chipActions } from '../slices/chips/slice';

// This middleware listens for tableConfig.fulfilled and sets game chips on initial game load.
export const chipsMiddleware = createListenerMiddleware();

chipsMiddleware.startListening({
  actionCreator: fetchTableConfigAction.fulfilled,
  effect: (action, { dispatch, getState }) => {
    const state = getState() as CoreRootState;
    const chipAmounts = state.config.tableConfig?.chipAmounts;

    if (chipAmounts) {
      dispatch(
        chipActions.setChips(chipAmounts.map((value, index) => ({ value, weight: getChipWeightFromIndex(index) })))
      );
    }
  },
});
